import { jsonStringifySort } from "./jsonStringifySort";

export const isJsonEqual = <T>(x: T, y: T): boolean =>
  jsonStringifySort(x) === jsonStringifySort(y);
